import React, { useState } from 'react'
import '../css/about.css'
import logo from '../imgs/LME.jpg'


export const Aboutus = () => {

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <section className="about">
        <h1>About Us</h1>
        {/* Corrected style attribute */}

        <div className="about-info">
          <div className="about-img">
            <img src={logo} alt="LOTUS META ENTERTAINMENT" />
          </div>
          <div className="text-container">
            <div className={`text-content ${isExpanded ? "expanded" : ""}`}>
              <p>
                Lotus meta entertainment LLP was initially promoted by legendary actor Kamal Hassan along with Mr Suresh Iyer to explore and venture beyond the existing and emerging contours of entertainment industry. Forayed in the territory of web3 – Metaverse along with Blockchain & NFT creation & auctioning, trade. To start with LME successfully launched the Vikram film NFT and metaverse.
              </p><br /><p> Driven solely by Suresh Iyer and LME IS collaborating with stalwarts, and Industry Professionals (national and international) to realise its original objectives in Media & Entertainment Sector. Driving the content in the Local Market and International & Decentralised Market place.
                With the group of professionals directly and indirectly involved LME always believed in the vision, art of seeing what is invisible to other; in the mission, just do not dream, bring in the motion – action, with an aim choose your aim amidst lot in there.

              </p>
            </div>
            <button className="about-btn" onClick={toggleReadMore}>
              {isExpanded ? "Read Less" : "Read More"}
            </button>
          </div>
        </div>
      </section>




    </div>
  )
}
